import '@nlx-uvex/styleguide';
export default function appGlobalScript() {}
